import { useCallback, useEffect, useState, useRef } from "react";
import { isEmpty } from "@util/utils";

const SENSITIVE_FIELDS = ["bankCode", "bankAccount", "bankAccountID"];

const useBankAccountState = (defaultValue) => {
	const [bankAccountInfo, setBankAccountInfo] = useState({});
	const hasClearedRef = useRef(false);
	const hasAnyDefaultRef = useRef(SENSITIVE_FIELDS.some((f) => !!defaultValue[f]));

	const handleUpdateField = useCallback((key, value) => {
			setBankAccountInfo((prev) => {
				const nextState = {
					...prev,
					[key]: value
				};

				const isSensitiveField = SENSITIVE_FIELDS.includes(key);

				if(isSensitiveField && hasAnyDefaultRef.current && !hasClearedRef.current) {
					// 清空其他敏感欄位（除了自己）
					SENSITIVE_FIELDS.forEach((field) => {
						if (field !== key) {
							nextState[field] = "";
						}
					});
					hasClearedRef.current = true;
				}

				return nextState;
			});
		},
		// eslint-disable-next-line
		[]);


	useEffect(() => {
			if (!isEmpty(defaultValue)) {
				setBankAccountInfo(defaultValue);
			}
		},
		// eslint-disable-next-line
		[defaultValue]);

	return { bankAccountInfo, onUpdateField: handleUpdateField };
};

export default useBankAccountState;